import { Component, Event, EventEmitter, Prop, h } from '@stencil/core';

@Component({
  tag: 'lab-ds-checkbox',
  styleUrl: 'lab-ds-checkbox.css',
  shadow: true,
})
export class LabDsCheckbox {
  @Event() handleCheckbox: EventEmitter;

  handleClick() {
    this.handleCheckbox.emit(this.checked);
    this.checked = !this.checked;
  }

  @Prop() label: string;

  @Prop() avatar: boolean = false;

  @Prop() error: boolean = false;

  @Prop() disabled: boolean = false;

  @Prop() checked: boolean = false;

  @Prop() wrapText: boolean = false;

  render() {
    return (
      <label class={`container ${this.disabled ? 'disabled' : ''} ${this.wrapText ? 'wrap-text' : ''}`}>
        {(this.avatar || this.label) && (
          <span class="container-label">
            {this.avatar ? <lab-ds-avatar size="small" /> : null}
            {this.label && <span class={`label-text ${this.checked ? 'checked' : ''}`}>{this.label}</span>}
          </span>
        )}
        <input checked={this.checked} onClick={() => this.handleClick()} disabled={this.disabled} type="checkbox" />
        <span class={`${this.error && 'error'} checkmark`}></span>
      </label>
    );
  }
}
